// extracted by mini-css-extract-plugin
export default {"themeToggle":"ThemeToggle_themeToggle__6VmbB"};